import figureFormatter from '@/services/utils/figureFormatter'

const registerColumns = {
    bill: [
        { key: 'date', label: 'Date', type: 'text' },
        { key: 'bill_number', label: 'Bill No', type: 'text' },
        { key: 'bill_referance_no', label: 'Ref No', type: 'text' },
        { key: 'supplier_name', label: 'Supplier', type: 'text' },
        { key: 'business_name', label: 'Business Unit', type: 'text' },
        { key: 'location_name', label: 'Location', type: 'text' },
        { key: 'line_discount', label: 'Line Discount', type: 'amount', has_total: true },
        { key: 'subtotal_amount', label: 'Sub Total', type: 'amount', has_total: true },
        { key: 'vat_amount', label: 'VAT', type: 'amount', has_total: true },
        { key: 'bill_amount', label: 'Bill Amount', type: 'amount', has_total: true },
        { key: 'return_amount', label: 'Return', type: 'amount', has_total: true },
        { key: 'net_amount', label: 'Net Bill', type: 'amount', has_total: true },
        { key: 'paid_amount', label: 'Paid', type: 'amount', has_total: true },
        { key: 'adjustment_amount', label: 'Adjustment', type: 'amount', has_total: true },
        { key: 'due', label: 'Due', type: 'amount', has_total: true }
    ],
    item: [
        { key: 'product_name', label: 'Item', type: 'text' },
        { key: 'unit_name', label: 'Unit', type: 'text' },
        { key: 'average_rate', label: 'Avg Rate', type: 'amount', has_total: false },
        { key: 'quantity', label: 'Qty', type: 'quantity', has_total: true },
        { key: 'return_quantity', label: 'Return Qty', type: 'quantity', has_total: true },
        { key: 'net_quantity', label: 'Net Qty', type: 'quantity', has_total: true },
        { key: 'gross_amount', label: 'Gross Amount', type: 'amount', has_total: true },
        { key: 'discount_amount', label: 'Discount', type: 'amount', has_total: true },
        { key: 'vat_amount', label: 'VAT', type: 'amount', has_total: true },
        { key: 'total_amount', label: 'Total', type: 'amount', has_total: true },
        { key: 'return_amount', label: 'Return Amount', type: 'amount', has_total: true },
        { key: 'net_amount', label: 'Net Amount', type: 'amount', has_total: true }
    ],
    supplier: [
        { key: 'supplier_name', label: 'Supplier', type: 'text' },
        { key: 'contact_no', label: 'Contact No', type: 'text' },
        { key: 'bill_count', label: 'Bills', type: 'quantity', has_total: true },
        { key: 'bill_amount', label: 'Bill Amount', type: 'amount', has_total: true },
        { key: 'vat_amount', label: 'VAT', type: 'amount', has_total: true },
        { key: 'return_amount', label: 'Return', type: 'amount', has_total: true },
        { key: 'net_amount', label: 'Net', type: 'amount', has_total: true },
        { key: 'paid_amount', label: 'Paid', type: 'amount', has_total: true },
        { key: 'adjustment_amount', label: 'Adjustment', type: 'amount', has_total: true },
        { key: 'due', label: 'Due', type: 'amount', has_total: true }
    ]
}

const registerTitles = {
    bill: 'Purchase Register - Bill Wise',
    item: 'Purchase Register - Item Wise',
    supplier: 'Purchase Register - Supplier Wise'
}

const purchaseRegisterColumns = () => {
    const { commaFormat } = figureFormatter()

    const getColumns = (tab) => {
        return registerColumns[tab] || []
    }

    const getTitle = (tab) => {
        return registerTitles[tab] || 'Purchase Register'
    }

    const isNumeric = (column) => {
        return column.type !== 'text'
    }

    const getContactNo = (row) => {
        return [row.phone, row.mobile_no].filter(Boolean).join(', ')
    }

    const formatValue = (value, column) => {
        if (column.type === 'amount' && ! Number(value)) return '0.00'
        if (column.type === 'amount') return commaFormat(value)
        if (value === null || value === undefined) return ''
        return value
    }

    const formatCell = (row, column) => {
        if (column.key === 'contact_no') return getContactNo(row)
        return formatValue(row[column.key], column)
    }

    const formatTotal = (totals, column) => {
        if (! column.has_total) return ''
        if (! totals) return ''
        return formatValue(totals[column.key], column)
    }

    return {
        getColumns,
        getTitle,
        isNumeric,
        formatCell,
        formatTotal
    }
}

export default purchaseRegisterColumns
